import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClawd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconClawd"><Path fillRule="evenodd" clipRule="evenodd" d="M20 4V8H24V12H20V20H18V16H16V20H14V16H10V20H8V16H6V20H4V12H0V8H4V4H20ZM16 6V8H18V6H16ZM6 8H8V6H6V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClawd;
